// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"XO-z","categoryName":"YO-z","categoryNameSearchHeader":"ZO-z","categoryContent":"_O-z","bottomAligned":"aP-z","image":"bP-z","imageNoBackground":"cP-z"};